var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 465,
    viewBox: "0 0 332 465",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 331,
    height: 465,
    rx: 4,
    fill: "#545456"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 4C0.25 1.79086 2.10242 0 4.3875 0H327.112C329.398 0 331.25 1.79086 331.25 4V97.4656H0.25V4Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 97.4656H331.25C264.118 125.745 198.495 131.476 174.075 130.807C87.7618 133.378 22.2278 109.651 0.25 97.4656Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileField);
export default __webpack_public_path__ + "static/media/mobileField.8f545b4d7e58381c774b6d6375a2d5c3.svg";
export { ForwardRef as ReactComponent };